var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 64,
    viewBox: "0 0 66 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 64,
    rx: 20,
    transform: "matrix(-1 0 0 1 66 0)",
    fill: "#03D3E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0984 31.4476C39.037 31.4376 38.9749 31.433 38.9128 31.4338H28.3306L28.5613 31.3265C28.7869 31.2197 28.9921 31.0744 29.1677 30.8972L32.1352 27.9297C32.526 27.5566 32.5917 26.9564 32.2908 26.5076C31.9407 26.0294 31.2691 25.9256 30.7909 26.2757C30.7522 26.304 30.7155 26.3349 30.681 26.3681L25.3148 31.7343C24.8954 32.1532 24.895 32.8327 25.3139 33.2521C25.3142 33.2524 25.3145 33.2527 25.3148 33.253L30.681 38.6192C31.1007 39.0377 31.7802 39.0368 32.1988 38.6171C32.2317 38.584 32.2625 38.5489 32.2908 38.5118C32.5917 38.0631 32.526 37.4629 32.1352 37.0898L29.1731 34.1169C29.0156 33.9593 28.8346 33.8271 28.6365 33.7252L28.3145 33.5803H38.8537C39.402 33.6007 39.883 33.2177 39.986 32.6788C40.0809 32.0937 39.6835 31.5425 39.0984 31.4476Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.8d52f244ae9146303ab6ae0889c84231.svg";
export { ForwardRef as ReactComponent };